import { serviceRequest } from 'utils/http';
import { ProductUpdateService } from 'common/api';

export function setSiteEmployeeProductUpdatesReadAPI(siteEmployeeId: string) {
  return serviceRequest(() =>
    ProductUpdateService.productUpdateControllerSetRead(siteEmployeeId)
  );
}
